import getConfig from 'next/config';
import { Router } from 'next/router';
import { useEffect } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { isClient } from '@utils/helpers';

const PostHogWrapper = ({ children }) => {
  const {
    publicRuntimeConfig: { postHogKey = '', postHogHost = '' },
  } = getConfig();

  const cookiebot = isClient ? window.Cookiebot : undefined;
  const isCookieConsentStatisticsEnabled = () =>
    cookiebot?.consent?.statistics || false;

  useEffect(() => {
    if (!cookiebot || !postHogKey) {
      return;
    }

    posthog.init(postHogKey, {
      // eslint-disable-next-line camelcase -- FIXME
      api_host: postHogHost || 'https://eu.i.posthog.com',
      // eslint-disable-next-line camelcase -- FIXME
      opt_out_capturing_by_default: !isCookieConsentStatisticsEnabled(),
      // eslint-disable-next-line no-shadow -- FIXME
      loaded: posthog => {
        posthog.debug();
      },
    });

    const changePostHogConsent = () => {
      if (isCookieConsentStatisticsEnabled()) {
        posthog.opt_in_capturing();
      } else {
        posthog.opt_out_capturing();
      }
    };

    const handleRouteChange = () => posthog?.capture('$pageview');

    window.addEventListener('CookiebotOnAccept', changePostHogConsent);
    window.addEventListener('CookiebotOnDecline', changePostHogConsent);
    Router.events.on('routeChangeComplete', handleRouteChange);

    // eslint-disable-next-line consistent-return -- FIXME
    return () => {
      window.removeEventListener('CookiebotOnAccept', changePostHogConsent);
      window.removeEventListener('CookiebotOnDecline', changePostHogConsent);
      Router.events.off('routeChangeComplete', handleRouteChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};

export default PostHogWrapper;
